import React, { useMemo } from 'react';
import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import CollapseItem from '../../../../../../components/collapseItem';
import { useRoles } from '../../Connectable.hooks';
import { ListItem } from './ListItem';

const RolesSectionContent = ({ roles }: { roles: string }) => {
    return (
        <ListItem
            label={TranslationHelper.translate('Assigned roles')}
            value={roles}
        />
    );
};

type Props = {
    roleIds: number[];
};

export const RolesSection = ({ roleIds }: Props) => {
    const roles = useRoles();

    const rolesToDisplay = useMemo(() => {
        const roleNames = roles?.filter((role) => roleIds.includes(role.id));
        return (
            roleNames
                ?.sort((a, b) => a.name.localeCompare(b.name))
                .map((role) => role.name)
                .join(', ') ?? ''
        );
    }, [roleIds, roles]);

    return (
        <CollapseItem
            title={TranslationHelper.translate('Roles')}
            content={<RolesSectionContent roles={rolesToDisplay} />}
            collapsed={false}
        />
    );
};
